import { baseApi } from "./baseApi";
import * as API from "@utils/apiPath";
import type { ApiResponse, PagePayload } from "interface/page";
import type { StatusInterface } from "interface/common";

export const pageApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getPages: builder.query<ApiResponse, { [key: string]: string | number }>({
      query: (params) => ({
        url: API.GET_PAGE,
        method: "GET",
        params,
      }),
      providesTags: ["Page"],
    }),
    createPage: builder.mutation<ApiResponse, PagePayload>({
      query: ({ params }) => ({
        url: API.GET_PAGE,
        method: "POST",
        body: params,
      }),
      invalidatesTags: ["Page"],
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
          arg.onClose();
        } catch (error) {
          console.error("Failed to create page:", error);
        }
      },
    }),
    updatePage: builder.mutation<ApiResponse, PagePayload>({
      query: ({ params }) => ({
        url: API.GET_PAGE,
        method: "PUT",
        body: params,
      }),
      invalidatesTags: ["Page"],
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
          arg.onClose();
        } catch (error) {
          console.error("Failed to update page:", error);
        }
      },
    }),
    deletePage: builder.mutation<ApiResponse, string>({
      query: (id) => ({
        url: `/${API.GET_PAGE}/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Page"],
      async onQueryStarted(_arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (error) {
          console.error("Failed to delete page:", error);
        }
      },
    }),
    updatePageStatus: builder.mutation<ApiResponse, StatusInterface>({
      query: ({ id, ...body }) => ({
        url: `/${API.GET_PAGE}/status/${id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["Page"],
      async onQueryStarted(_arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (error) {
          console.error("Failed to update page status:", error);
        }
      },
    }),
    bulkUpdatePageStatus: builder.mutation<
      ApiResponse,
      { ids: string[]; status: boolean }
    >({
      query: ({ ids, status }) => ({
        url: `/${API.GET_PAGE}/bulk-status`,
        method: "PUT",
        body: { ids, status },
      }),
      invalidatesTags: ["Page"],
    }),
    bulkDeletePages: builder.mutation<ApiResponse, { ids: string[] }>({
      query: ({ ids }) => ({
        url: `/${API.GET_PAGE}/bulk-delete`,
        method: "DELETE",
        body: { ids },
      }),
      invalidatesTags: ["Page"],
    }),
  }),
});

export const {
  useGetPagesQuery,
  useCreatePageMutation,
  useUpdatePageMutation,
  useDeletePageMutation,
  useUpdatePageStatusMutation,
  useBulkUpdatePageStatusMutation,
  useBulkDeletePagesMutation,
} = pageApi;

